import React, {useRef, useState} from 'react';
import Form from "react-bootstrap/Form";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/Button";
import {getFloors} from "../../api/apiClient";
import ComboFclty from "../../components/inputs/ComboFclty";

/* 시설명, 층선택, 장비유형, 설정상태, 장비명 검색 컴포넌트 */
const FacilityFloorEquipmentSettingNameSearchBox = ({
                                                      propSensorSearch,
                                                      setSensorSearch,
                                                      showPopup,
                                                      propUpdate,
                                                      propAuth
                                                    }) => {
  /* 해당 시설 층 목록정보 data */
  const [stFloorList, setFloorList] = useState([]);
  const inputFloorSelectRef = useRef(null);

  // 시설 변경 시 층 목록 갱신 및 검색항목 갱신
  const onChangeFacilityName = (e) => {
    e.preventDefault();
    let val = e.target.value;
    let idx = e.nativeEvent.target.selectedIndex;

    // console.log('val: ', val);
    // console.log('idx: ', idx);

    if (val === 0 || val === '') {
      setSensorSearch((prev) => {
        return {...prev, fcltyCd: 0, fcltyNm: '', floorCd: 0};
      });
      // inputFloorSelectRef.current.disabled = true;
      // return;
    } else {
      setSensorSearch((prev) => {
        return {...prev, fcltyCd: val, fcltyNm: e.nativeEvent.target[idx].text, floorCd: 0};
      });
      // inputFloorSelectRef.current.disabled = false;
      // }
      // inputFloorSelectRef.current.disabled = false;
      getFloors('', val).then((response) => {
        setFloorList(response.data.data.list);
      });
    }
  };


  // 층 변경 시 검색항목 갱신
  const onChangeFloor = (e) => {
    e.preventDefault();
    let val = e.target.value
    setSensorSearch((prev) => {
      return {...prev, floorCd: val};
    });
  };

  return (
      <>
        <Form
            id={"searchForm"}
            className={"search-form"}
            // onSubmit={(e) => onSearch(e)}
        >
          <Row className={"justify-content-center"}>
            <Col md={12}>
              <Row className={"justify-content-around"}>
                <Col md={10}>
                  <Row>
                    <Col xxl={3} xl={4} lg={6} md={6}>
                      <ComboFclty propFilterDist={''}
                                  propOnChange={onChangeFacilityName}
                      />
                    </Col>
                    <Col xxl={3} xl={4} lg={6} md={6}>
                      <Form.Group as={Row} controlId="formBasicSelectMenu">
                        <Form.Label
                            className={`col-form-label label text-end`}
                            style={{width: "100px"}}
                        >
                          층선택
                        </Form.Label>
                        <Col>
                          <Form.Select
                              aria-label="Default select example"
                              className={"input-select"}
                              ref={inputFloorSelectRef}
                              onChange={onChangeFloor}
                              defaultValue={propSensorSearch.floorCd}
                              key={propSensorSearch.floorCd}
                              disabled={propSensorSearch.fcltyCd === 0}
                          >
                            <option value={''}>층을 선택하세요</option>
                            {Array.isArray(stFloorList) ?
                                (stFloorList.map((elem, idx) => {
                                  return (
                                      <option key={idx} value={elem.cd}>{elem.nm}</option>
                                  )
                                })) : ''}
                          </Form.Select>
                        </Col>
                      </Form.Group>

                    </Col>
                  </Row>
                </Col>

                <Col md={2} className={"search-btn-container text-center"}>
                  <Button onClick={propUpdate} className={"search-btn"}
                          style={{width: "100px"}}
                  >
                    검색
                  </Button>
                </Col>
              </Row>
            </Col>

            {/*{propAuth === "2" ?
                <Col md={3} className={"search-btn-container text-center"}>
                  <Row className={'btn-controls justify-content-center'}>
                    <Col md={3}>
                      <Button onClick={showPopup} className={"btn"}
                              style={{width: "100px"}}
                      >
                        등록
                      </Button>
                    </Col>
                  </Row>
                </Col>
                : ''}*/}
          </Row>
        </Form>
      </>
  );
};

export default FacilityFloorEquipmentSettingNameSearchBox;
